import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import dayjs from "dayjs";
import { CurrentLiveStream, TG4Stream, TG4StreamState } from '@/types/cms';
import { getCurrentInstance } from 'vue';
import { CMSLiveStreamManager } from '@/services/CMSLiveStreamManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'LiveStreamCell',
  props: {
    liveStream: null,
    textColor: null
  },
  setup(__props: any) {

const props = __props as {
  liveStream: CurrentLiveStream;
  textColor?: string;
};

const instance = getCurrentInstance();
const router = instance?.proxy?.$router;



const imageLoadFailed = ref(false);
const currentShow = computed(() => props.liveStream.currentShow);
const isStartTimeInFuture = computed(() => currentShow.value?.startTime ? dayjs(currentShow.value.startTime).isAfter(dayjs()) : false);

const isDisabled = computed(() => {
  if (!props.liveStream) return false;
  return props.liveStream.state === TG4StreamState.DISABLED || props.liveStream.state === TG4StreamState.UPCOMING;
});

const isCula4 = computed(() => {
  return props.liveStream?.stream === TG4Stream.CULA4;
});

const hasProgress = computed(() => {
  const show = props.liveStream?.currentShow;
  return show && show.startTime && show.endTime && !isStartTimeInFuture.value;
});

const progressColor = computed(() => {
  return isCula4.value ? '#a0f5b8' : '#e91e90';
});

const imageSource = computed(() => {
  if (imageLoadFailed.value) {
    return `assets/images/tg4FallbackImageSmall.png`;
  }

  // Use Cloudinary image from pcode
  if (props.liveStream?.currentShow?.pcode) {
    return `https://res.cloudinary.com/tg4/image/upload/w_700,h_395,c_fit,q_auto:eco/${props.liveStream.currentShow.scode}.jpg`;
  }

  return `assets/images/placeholder.png`;
});

const progressPercent = computed(() => {
  if (!props.liveStream?.currentShow?.startTime || !props.liveStream?.currentShow?.endTime) {
    return 0;
  }

  const start = dayjs(props.liveStream.currentShow.startTime);
  const end = dayjs(props.liveStream.currentShow.endTime);
  const now = dayjs();

  const total = end.diff(start, 'second');
  const elapsed = now.diff(start, 'second');

  if (total <= 0) return 0;
  return Math.min(100, Math.max(0, (elapsed / total) * 100));
});

const titleText = computed(() => {
  return currentShow.value?.title ?? '';
});

const timeText = computed(() => {
  const show = currentShow.value;
  if (!show?.startTime && !show?.endTime) return '';

  if (isStartTimeInFuture.value){
    return formatTimeAndDate(show.startTime);
  };


  var startTime = formatTime(show.startTime);
  if (!startTime) return '';
  var result = startTime;
  var endTime = formatTime(show.endTime);
  if (endTime) {
    result += ` - ${endTime}`;
  }
  return result;
});

const nextShowText = computed(() => {
  const nextShow = props.liveStream?.nextShow;
  if (!nextShow) return '';
  return nextShow.title ?? '';
});

const formatTime = (timeStr: string | null): string | null => {
  if (!timeStr) return null;
  return dayjs(timeStr).format("HH:mm");
};


const navigateToStream = () => {
  const stream = props.liveStream;
  if (!stream || !CMSLiveStreamManager.isStreamPlayable(stream)) return;
  router?.push({ path: CMSLiveStreamManager.playerPath(stream) });
};

const formatTimeAndDate = (timeStr: string | null): string => {
  if (!timeStr) return '';
  const date = new Date(timeStr);
  return date.toLocaleString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
    hour12: false
  });
};

const textStyle = computed(() => {
  if (props.textColor) {
    return {
      color: props.textColor,
    };
  }
  return {};
});


return { __sfc: true,instance, router, props, imageLoadFailed, currentShow, isStartTimeInFuture, isDisabled, isCula4, hasProgress, progressColor, imageSource, progressPercent, titleText, timeText, nextShowText, formatTime, navigateToStream, formatTimeAndDate, textStyle }
}

})